module.exports = __webpack_public_path__ + "static/media/feat_curtains.22bd6df7.png";